import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";

class DataDeletion extends Component {

    constructor (props) {
        super (props)
    }

    render (){

        return (
            <div>
                <Breadcrumb title={'Eliminación de Datos'}/>

                <section className="about-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <p><em>Última actualización: 16 de julio de 2026</em></p>

                                <p>En <strong>Wewith</strong> respetamos tu derecho a controlar tu información
                                    personal. Si deseas que eliminemos los datos asociados a tu cuenta, sigue estos
                                    pasos:</p>

                                <h4>Cómo solicitar la eliminación de tus datos</h4>
                                <ol>
                                    <li>Escríbenos por WhatsApp al número{' '}
                                        <a href="https://wa.me/51944847482" target="_blank" rel="noopener noreferrer">+51
                                            944 847 482</a>.</li>
                                    <li>Indica tu nombre completo y el número de teléfono o correo asociado a tu
                                        cuenta.</li>
                                    <li>Solicita expresamente la "eliminación de mis datos personales".</li>
                                </ol>

                                <p>Nuestro equipo verificará tu identidad y procesará la solicitud de forma manual,
                                    eliminando la información personal almacenada en nuestros sistemas, salvo aquella
                                    que debamos conservar por obligación legal o para la resolución de disputas.</p>

                                <h4>Tiempo de respuesta</h4>
                                <p>Procesaremos tu solicitud en un plazo máximo de 30 días desde su recepción, y te
                                    confirmaremos por el mismo medio una vez completada la eliminación.</p>

                                <h4>Contacto</h4>
                                <p>Para cualquier consulta sobre este proceso, contáctanos por WhatsApp al{' '}
                                    <a href="https://wa.me/51944847482" target="_blank" rel="noopener noreferrer">+51
                                        944 847 482</a>.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default DataDeletion
